"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PartnerSourcesRestriction = exports.PartnersDealType = exports.PartnerAllowedPaymentMethod = exports.PartnerAllowedDepartureType = void 0;
var PartnerAllowedDepartureType;
(function (PartnerAllowedDepartureType) {
    PartnerAllowedDepartureType["BoB"] = "bob";
    PartnerAllowedDepartureType["BoX"] = "box";
})(PartnerAllowedDepartureType = exports.PartnerAllowedDepartureType || (exports.PartnerAllowedDepartureType = {}));
var PartnerAllowedPaymentMethod;
(function (PartnerAllowedPaymentMethod) {
    PartnerAllowedPaymentMethod["CreditCard"] = "credit-card";
    PartnerAllowedPaymentMethod["VSCCreditCard"] = "vsc-credit-card";
    PartnerAllowedPaymentMethod["Paypal"] = "paypal";
    PartnerAllowedPaymentMethod["IOU"] = "iou";
})(PartnerAllowedPaymentMethod = exports.PartnerAllowedPaymentMethod || (exports.PartnerAllowedPaymentMethod = {}));
var PartnersDealType;
(function (PartnersDealType) {
    PartnersDealType["Booking"] = "booking";
    PartnersDealType["Whitelabel"] = "whitelabel";
    PartnersDealType["PoweredByWhitelabel"] = "powered_by_whitelabel";
    PartnersDealType["Referral"] = "referral";
})(PartnersDealType = exports.PartnersDealType || (exports.PartnersDealType = {}));
var PartnerSourcesRestriction;
(function (PartnerSourcesRestriction) {
    /** @deprecated use `Allowlist` */
    PartnerSourcesRestriction["Whitelist"] = "whitelist";
    PartnerSourcesRestriction["Allowlist"] = "whitelist";
    /** @deprecated use `Blocklist` */
    PartnerSourcesRestriction["Blacklist"] = "blacklist";
    PartnerSourcesRestriction["Blocklist"] = "blacklist";
})(PartnerSourcesRestriction = exports.PartnerSourcesRestriction || (exports.PartnerSourcesRestriction = {}));
//# sourceMappingURL=partners.js.map